<template>
    <div class="layout-container label-container">
        <el-tabs type="border-card">
            <el-tab-pane label="百科分类">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con">
                         <div class="search-condition">
                            <span class="label">分类名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.name" placeholder="请输入标签" maxlength="6"></el-input>
                            </div>
                        </div>
                        <el-button class="label-search-btn"  type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button class="label-search-btn"  @click="resetSearch()">清空条件</el-button>
                    </div>
                   
                </div>
                <div class="clearfix" style="margin-bottom: 5px" >
                        <el-button-group class="floatR" >
                             <el-button  @click="handleAdd" icon="el-icon-plus"  v-permission="'operating.wikipedia.categories.list.create'">新增分类</el-button>
                        </el-button-group>
                </div>
                <div class="table-detail-list">
                   <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        row-key="id"
                        border
                        default-expand-all
                        :tree-props="{children: 'children'}">
                        <el-table-column  label="分类名称" prop="name"></el-table-column>
                        <el-table-column  label="添加人" prop="creator" ></el-table-column>
                        <el-table-column  label="添加时间" prop="created_at"></el-table-column>
                        <el-table-column  label="排序" prop="sort">
                            <template slot-scope="{row, $index}">
                                <inline-editable-input v-permission="'operating.wikipedia.categories.list.edit'" :value="row.sort" @input="(value) => changeEdit(value, row)"></inline-editable-input>
                            </template>
                        </el-table-column>
                        <el-table-column  label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"  v-permission="'operating.wikipedia.categories.list.edit'" >编辑</el-button>
                                <el-button size="mini" type="danger"  @click="handleDelete(scope.row.id)"  v-permission="'operating.wikipedia.categories.list.delete'" >删除</el-button>
                            </template>
                        </el-table-column>
                    
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <add ref="add" :callback="initData" />
        <edit ref="edit" :callback="initData" />
    </div>
    
    
</template>

<script>
    import { categoriesList,deleteCategorie,editWikipediaCatSort } from '@/service/wikipedia'
    import add from './component/add'
    import edit from './component/edit'
    import InlineEditableInput from "@/components/inlineEditableInput/index";

    export default {
        name: "baikeList",
        components: {
            add,edit,InlineEditableInput
        },
        data () {
            return {
                isLoading:false,
                condition: {
                    name:'',
                },
                list:[],
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            initData(){
                this.list=[]
                this.isLoading = true;
                categoriesList(this.condition).then(data => {
                    if(data.length){
                        data.forEach(el => {
                            if(el.sub_category.length){
                                el.children=el.sub_category
                            }
                        });
                        this.list = data;
                    }
                });
    
                this.isLoading = false;

            },
            handleSearch(){
                this.initData()
            },
            resetSearch(){
                this.condition.name=""
                this.initData();
            },
            handleDelete(id) {
                this.$confirm("删除后不可撤回，是否确认操作？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteCategorie(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
                },
            handleAdd() {
                this.$refs.add
                && this.$refs.add.open()
            },
            handleEdit(index,row){
                this.$refs.edit && this.$refs.edit.open(row)
            },
            changeEdit (value, row) {
                let old = row.sort;
                row.sort = value;
                if (/^-?\d+$/.test(value) === false || value > 9999 || value < -9999 || value === '-0') {
                    this.$nextTick(_ => {row.sort = old});
                    this.$message({
                        type: 'error',
                        message: '请输入-9999-9999之间的排序数字'
                    });
                    return
                }
                editWikipediaCatSort(row.id, {
                    sort: value,
                }).then(_ => {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                }).catch (e => {
                    row.sort = old;
                    this.$message({
                        type: 'error',
                        message: e.message || '修改排序错误'
                    })
                })
            },
        }
         
    }
</script>
<style>
    .label-search-btn{
        height: 36px;
        line-height: 36px;
        padding: 0 20px;
    }
</style>

 
